import React from 'react';
import { Link } from 'react-router-dom';

import style from './Expired.module.css';

const ResetPasswordConfirm = React.memo(() => (
  <section className={style.forgotPassword}>
    <h2 className={style.h2}>
      Your password has been changed. Please <Link to="/login">log in</Link>
    </h2>
  </section>
));

export default ResetPasswordConfirm;
